export function offsetToPage(offset: number, limit: number, firstPage: number = 0) {
  if (offset === 0) {
    return firstPage;
  }
  return offset / limit + firstPage;
}

export function pageToOffset(page: number, limit: number, firstPage: number = 0) {
  return (page - firstPage) * limit;
}
